export enum TriggerOn {
  UserTriggered,
  EndOfTransaction,
}
